module.exports = "<app-photo-view photo-list=$ctrl.poi.photos main-lang=$ctrl.poi.main_lang></app-photo-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/photos/partial.html
// module id = 457
// module chunks = 0